module.exports = __webpack_public_path__ + "assets/img/5.50cb32fd.png";